import { getBasePath } from './path';

interface State {
  cache: Record<string, HTMLAudioElement>,
  mute: boolean,
  queue: Array<() => void>,
  playing: boolean,
}

const state: State = {
  cache: {},
  mute: false,
  queue: [],
  playing: false,
};

const types = [
  {
    extension: 'ogg',
    type: 'audio/ogg',
  },
  {
    extension: 'mp3',
    type: 'audio/mpeg',
  },
];

export enum soundTypes {
  ENDSOUND = 'endsound',
  INVITE_GAME = 'invite_game',
  JOIN = 'join',
  NEW_TURN = 'new_turn',
}

export const mute = (mute: boolean): void => {
  state.mute = mute;
}

const playFromQueue = (): void => {
  if (!state.queue.length) {
    return;
  }

  const l = state.queue.shift();
  l!();
}

const get = (name: string): HTMLAudioElement => {
  let audio = state.cache[name] ?? null;
  if (audio === null) {
    audio = document.createElement('audio');
    for (const t of types) {
      const source = document.createElement('source');
      source.src = getBasePath()+'sounds/'+name+'.'+t.extension;
      source.type = t.type;
      audio.appendChild(source);
    }
    audio.addEventListener('ended', (e) => { state.playing = false; playFromQueue(); });
    state.cache[name] = audio;
  }
  return audio;
}

const playImpl = (audio: HTMLAudioElement): void => {
  state.playing = true;
  const promise = audio.play();
  if (promise !== undefined) {
    promise.then(_ => {
    }).catch(error => {
      // Sound was blocked because the user haven't interacted with the page
    });
  }
}

const playIfPossible = (l: () => void) => {
  if (state.playing) {
    state.queue.push(l);
    return;
  }

  l();
}

export const play = (name: string): void => {
  if (state.mute) {
    return;
  }

  playIfPossible(() => {
    const audio = get(name);
    playImpl(audio);
  });
}

export const preload = (): void => {
  playIfPossible(() => {
    for (let name of Object.values(soundTypes)) {
      get(name);
    }
  });
}